import React from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsAdsTable from './BreadcrumbsAdsTable';
import { ADS, navigationMapping } from '../../../consts/navigation';
import BreadcrumbsAdsDefault from '../BreadcrumbsAdsDefault/BreadcrumbsAdsDefault';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsAds = (props) => {
  const { pathname, t, } = props;
  if (pathname === navigationMapping[ADS].table_url) {
    return <BreadcrumbsAdsTable {...props} />;
  }

  return (
    <>
      <BreadcrumbsAdsDefault
        name={t('new_ad')}
      />
    </>
  );
};

BreadcrumbsAds.propTypes = {
  pathname: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withScopedTranslations('breadcrumbs.ads')(BreadcrumbsAds);
